import React, { useState, useEffect } from "react";
import ComboSelector, { TipoClave } from "../UI/campos/ComboSelector.js";
import MensajeCargando from "../UI/MensajeCargando.js";
import MensajeError from "../UI/MensajeError.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";

const SelectEstadio = (props) => {
  const idTorneo = props.idTorneo;
  const idPais = props.idPais;
  const fecha = props.fecha;
  const estadioActual = props.estadio;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    // Validation: cannot provide both idTorneo and idPais
    if ((idTorneo !== undefined && idTorneo !== null) && (idPais !== undefined && idPais !== null)) {
      // invalid props combination: clear list and return
      console.error('SelectEstadio: no se pueden informar idPais e idTorneo a la vez');
      resetErroresGetLista();
      setLista([]);
      return;
    }

    // If idTorneo is provided, query torneo/{id}/estadios (optionally with fecha)
    if (idTorneo !== undefined && idTorneo !== null) {
      let url = `torneos/${idTorneo}/estadios`;
      if (fecha !== undefined && fecha !== null) url += `?fecha=${fecha}`;
      fetchData(url, setLista);
      return;
    }

    // If idPais is provided, query paises/{id}/estadios (optionally with fecha)
    if (idPais !== undefined && idPais !== null) {
      let url = `paises/${idPais}/estadios`;
      if (fecha !== undefined && fecha !== null) url += `?fecha=${fecha}`;
      fetchData(url, setLista);
      return;
    }

    // No idTorneo nor idPais -> fecha is required
    if (fecha === undefined || fecha === null) {
      console.error('SelectEstadio: fecha is required when idTorneo and idPais are not provided');
      resetErroresGetLista();
      setLista([]);
      return;
    }

    // General estadios endpoint with fecha
    let url = `estadios?fecha=${fecha}`;
    fetchData(url, setLista);
  }, [fetchData, idTorneo, idPais, fecha]);

  const onEstadioElegido = (estadio) => {
    props.onEstadioElegido(estadio);
  };

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={estadioActual ? estadioActual.descripcion : ""}
        campoClave={TipoClave.ID}
        campoDescripcion="nombre"
        isCargando={isCargando}
        onItemElegido={onEstadioElegido}
      />
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectEstadio;
